import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="resend-otp"
export default class extends Controller {
  static targets = ["linkTemplate"]
  static values = { delay: { type: Number, default: 3000 } }

  connect() {
    // After delay, replace the success message with the link again
    setTimeout(() => {
      this.showLink()
    }, this.delayValue)
  }

  showLink() {
    if (this.hasLinkTemplateTarget) {
      const linkContent = this.linkTemplateTarget.content.cloneNode(true)
      this.element.replaceWith(linkContent)
    }
  }
}

